import { Component, ElementRef, Renderer2 } from '@angular/core'
import { MbSubmitOrderBase } from '../mb-submit-order-base'
import { CartCheckoutService } from '../../../services/mb-cart-checkout.service'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Component({
  selector: 'mb-submit-order-steps',
  templateUrl: './mb-submit-order-steps.component.html',
  styleUrls: ['../mb-submit-order-base.scss']
})
export class MbSubmitOrderStepsComponent extends MbSubmitOrderBase {

  constructor (protected activeCartService: ActiveCartService,
              protected elem: ElementRef,
               protected renderer: Renderer2,
               protected cartCheckoutService: CartCheckoutService) {
    super(activeCartService, elem, renderer, cartCheckoutService)
  }
}
